import { Spinner } from "@heroui/react";
import { FiCheckCircle, FiFileText, FiInfo } from "react-icons/fi";
import { CustomPopover } from "../../../../components/shared/Popover";
import { useMessageCitations } from "../../../../lib/react-query/aiChat";

const titleFor = (citation) =>
  citation?.title ||
  citation?.source_title ||
  citation?.knowledge_title ||
  citation?.file_name ||
  `${citation?.source_type || "Source"} ${citation?.source_id || ""}`;

export const CitationDetailPopover = ({
  open,
  setOpen,
  trigger,
  sessionId,
  messageId,
}) => {
  const { data, isLoading } = useMessageCitations(sessionId, messageId, open);
  const citations = Array.isArray(data?.citations) ? data.citations : Array.isArray(data) ? data : [];

  return (
    <CustomPopover open={open} setOpen={setOpen} trigger={trigger} placement="top">
      <div className="w-80 rounded-xl border border-surface-border bg-white p-3 shadow-lg">
        <p className="mb-2 text-xs font-semibold text-primary">Sources</p>
        {isLoading ? (
          <div className="flex justify-center py-4"><Spinner size="sm" /></div>
        ) : citations.length ? (
          <div className="space-y-2">
            {citations.map((citation, index) => (
              <div key={`${citation?.source_type}-${citation?.source_id}-${index}`} className="rounded-lg bg-surface p-2">
                <div className="flex items-start gap-2">
                  <FiFileText className="mt-0.5 shrink-0 text-primary" aria-hidden="true" />
                  <div className="min-w-0">
                    <p className="truncate text-xs font-semibold text-darkgrey">{titleFor(citation)}</p>
                    <p className="mt-1 line-clamp-4 text-xs text-mediumgrey">{citation?.snippet || "No snippet available."}</p>
                    <div className="mt-1 flex flex-wrap items-center gap-2 text-[10px] text-grey">
                      {citation?.page_range ? <span>{citation.page_range}</span> : null}
                      {citation?.valid === false ? (
                        <span className="inline-flex items-center gap-1 text-danger"><FiInfo /> No longer accessible</span>
                      ) : (
                        <span className="inline-flex items-center gap-1 text-success"><FiCheckCircle /> Valid</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="py-3 text-xs text-grey">No citations saved for this answer.</p>
        )}
      </div>
    </CustomPopover>
  );
};
